import type { Configuration, RedirectRequest } from '@azure/msal-browser';
import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `${import.meta.env.VITE_AZURE_AUTHORITY}/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      // Errors and warnings only, and only in development: redirect failures are otherwise
      // invisible (the page silently falls back to the sign-in button).
      loggerCallback: (level, message, containsPii) => {
        if (!import.meta.env.DEV || containsPii) {
          return;
        }
        if (level === LogLevel.Error) {
          console.error(message);
        }
        else if (level === LogLevel.Warning) {
          console.warn(message);
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
  extraQueryParameters: {
    claims: JSON.stringify({
      id_token: {
        roles: { essential: true },
      },
    }),
  },
};

export const apiTokenRequest: RedirectRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE],
};

export const silentTokenRedirectUri = `${window.location.origin}/auth/silent-callback.html`;

export const pca = new PublicClientApplication(msalConfig);
